import { render } from "./AggregateTrucks.vue?vue&type=template&id=1e4a5e39"
import script from "./AggregateTrucks.vue?vue&type=script&lang=js"
export * from "./AggregateTrucks.vue?vue&type=script&lang=js"

import "./AggregateTrucks.vue?vue&type=style&index=0&id=1e4a5e39&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__